<template>
  <div style="width: 100%;">
    <v-container fluid>
      <v-row>
        <v-col class="d-flex flex-row">
          <h1>Dispatch Dashboard</h1>
          <v-progress-circular
              indeterminate
              color="green"
              v-if="loader"
              style="margin-left: 10px;"
          ></v-progress-circular>
        </v-col>
      </v-row>
      <v-row>
        <v-col>
          <div>
            <span class="d-flex flex-row align-center">
              <span class="mr-5">
                <v-text-field hide-details label="Go To Dispatch #" dense outlined @change="goToDocument" v-model="dispatchIdSearch" :loading="goToDocumentLoader"/>
              </span>
              <v-btn color="info" @click="openOtherStatusesDialog">View Other Statuses</v-btn>
            </span>
          </div>
        </v-col>
      </v-row>
      <v-row>
        <v-col cols="2">
          <v-card>
            <v-card-text style="padding-left: 9px; padding-right: 1px;">
              <div class="d-flex flex-row">
                <div class="d-flex flex-column mr-2 align-center" :style="'height: 75vh; width: 100%; border: 1px solid grey; border-radius: 7px; padding: 10px;'">
                  <h2 style="min-height: 30px;">Incomplete Orders ({{incompleteOrders.length}})</h2>
                  <span v-if="incompleteOrdersData.filter==='all'" class="text-center">These are all orders that have not been completely delivered.</span>
                  <span v-else-if="incompleteOrdersData.filter==='new'" class="text-center">These are all orders that have no completed dispatches.</span>
                  <span v-else-if="incompleteOrdersData.filter==='old'" class="text-center">These are all orders that have some products fulfilled.</span>
                  <span class="d-flex flex-column justify-center">
                    <v-btn
                        small
                        class="mb-2 align-self-center"
                        color="info"
                        v-if="incompleteOrdersData.sortBy==='id'"
                        @click="loadIncompleteOrders('sealedAt')"
                    >
                      <span><v-icon>mdi-sort-clock-ascending</v-icon> Sealed Date</span>
                    </v-btn>
                    <v-btn
                        small
                        class="mb-2 align-self-center"
                        color="info"
                        v-else
                        @click="loadIncompleteOrders('id')"
                    >
                      <span><v-icon>mdi-sort-variant</v-icon> Order ID</span>
                    </v-btn>
                    <v-btn
                        small
                        class="mb-2 align-self-center"
                        color="warning"
                        v-if="incompleteOrdersData.filter==='all'"
                        @click="loadIncompleteOrders(null, 'new')"
                    >
                      <span><v-icon>mdi-book-open-blank-variant-outline</v-icon> Show Untouched Only</span>
                    </v-btn>
                    <v-btn
                        small
                        class="mb-2 align-self-center"
                        color="warning"
                        v-else-if="incompleteOrdersData.filter==='new'"
                        @click="loadIncompleteOrders(null, 'old')"
                    >
                      <span><v-icon>mdi-book-open-blank-variant-outline</v-icon> Show Touched Only</span>
                    </v-btn>
                    <v-btn
                        small
                        class="mb-2 align-self-center"
                        color="warning"
                        v-else
                        @click="loadIncompleteOrders(null, 'all')"
                    >
                      <span><v-icon>mdi-filter</v-icon> Show All</span>
                    </v-btn>
                  </span>
                  <div class="d-flex flex-column " style="width: 100%; height: 100%; overflow-y: scroll;">
                    <v-progress-circular
                        indeterminate
                        color="green"
                        v-if="incompleteOrdersLoader"
                    />
                    <span v-else>
                      <v-card outlined v-for="(order, j) of incompleteOrders" style="width: 100%" class="mb-2" :key="j" @click="rowClick(order.id)" @mousedown.middle.prevent="rowMiddleClick(order.id)">
                        <v-card-text class="d-flex flex-column">
                          <span class="d-flex flex-row justify-space-between align-center">
                            <b class='mr-2' style="color: purple">Order #{{ order.id }}</b>
                            <span v-if="order.Dispatches && order.Dispatches.length>0">
                              <v-icon small>mdi-book-open-blank-variant</v-icon> ({{order.Dispatches.length}})
                            </span>
                            <span v-else>
                              <v-icon small>mdi-book-open-blank-variant-outline</v-icon>
                            </span>
                          </span>
                          <div style="font-size: 12px;">{{ utils.formatDate(order.sealedAt) }}</div>
                          <div>{{ order.Customer?(order.Customer.name?order.Customer.name:(order.Customer.firstName||order.Customer.lastName?(`${order.Customer.firstName||''} ${order.Customer.lastName||''}`):'-')):"-" }}</div>
                          <span v-if="order.deliveryInfo.address && Object.keys(order.deliveryInfo.address).map(x => order.deliveryInfo.address[x]).join('').trim().length>0" class="d-flex flex-row align-center">
                            <v-icon small class="mr-2">mdi-map-marker</v-icon>
                            <span>
                              <div v-if="order.deliveryInfo.address.city">{{ order.deliveryInfo.address.city }}</div>
                              <div v-else style="font-size: 11px;" class="d-flex flex-column">
                                <span style="line-height: 11px;">{{ order.deliveryInfo.address.line1 }}</span>
                                <span v-if="order.deliveryInfo.address.line2" style="line-height: 11px;">{{ order.deliveryInfo.address.line2 }}</span>
                              </div>
                            </span>
                          </span>
                        </v-card-text>
                      </v-card>
                    </span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
        <v-col cols="10">
          <v-card>
            <v-card-text class="">
              <div class="d-flex flex-row">
                <div v-for="(board, i) of boardData.filter(x => x.data.length>0 && !x.onlyShowOnModal)" :key="i" class="d-flex flex-column mr-2 align-center" :style="'height: 75vh; width: '+Math.floor(100/boardData.filter(x => !x.onlyShowOnModal && x.data.length>0).length)+'%; border: 1px solid grey; border-radius: 7px; padding: 10px;'">
                  <h2 style="min-height: 60px;">{{ utils.parseDispatchStatus(board.status) }} ({{board.count}})</h2>
                  <div :ref="`statusScroll_${board.status}`" class="d-flex flex-column " style="width: 100%; height: 100%; overflow-y: scroll;">
                    <v-card outlined v-for="(dispatch, j) of board.data" style="width: 100%" class="mb-2" :key="j" @click="rowClick(dispatch.orderId, dispatch.id)"  @mousedown.middle.prevent="rowMiddleClick(dispatch.orderId, dispatch.id)">
                      <v-card-text class="d-flex flex-column">
                        <span class="d-flex flex-row justify-space-between">
                          <b v-if="dispatch.id" class='mr-2'>{{ dispatch.orderId }}-{{ dispatch.id }}</b>
                          <b v-else class='mr-2' style="color: rebeccapurple">Order #{{ dispatch.orderId }}</b>
                          <span class="d-flex flex-row align-center">
                            <v-icon v-if="![0, -1, 5, -2].includes(dispatch.status) && dispatch.scheduledOutAt && !(new Date(dispatch.scheduledOutAt) >= new Date())" color="warning">mdi-clock-alert</v-icon>
                            <div class="align-center">
                              <v-icon small class="mr-2">mdi-package</v-icon>
                              <span>{{ dispatch.numItems }}</span>
                            </div>
                          </span>
                        </span>
                        <div style="font-size: 12px;">{{ dispatch.boardDate }}</div>
                        <div>{{ dispatch.customer }}</div>
                        <span v-if="dispatch.address && Object.keys(dispatch.address).length>0" class="d-flex flex-row align-center">
                          <v-icon small class="mr-2">mdi-map-marker</v-icon>
                          <span>
                            <div v-if="dispatch.address.city">{{ dispatch.address.city }}</div>
                            <div v-else style="font-size: 11px;" class="d-flex flex-column">
                              <span style="line-height: 11px;">{{ dispatch.address.line1 }}</span>
                              <span v-if="dispatch.address.line2" style="line-height: 11px;">{{ dispatch.address.line2 }}</span>
                            </div>
                          </span>
                        </span>
                      </v-card-text>
                    </v-card>
                    <span class="d-flex flex-row justify-space-around">
                      <v-progress-circular v-if="!board.isLoading && board.count!==board.data.length" v-intersect="(entries, observer, isIntersecting) => loadStatus(board.status, entries, observer, isIntersecting)" color="success" indeterminate/>
                    </span>
                  </div>
                </div>
              </div>
            </v-card-text>
          </v-card>
        </v-col>
      </v-row>
    </v-container>

    <v-dialog
        width="90%"
        v-model="otherStatusesDialog.isOpen"
        transition="dialog-bottom-transition"
    >
      <v-card>
        <v-card-title class="d-flex flex-row justify-space-between align-center">
          <span>Other Statuses</span>
          <v-btn text @click="closeOtherStatusesDialog"><v-icon>mdi-close</v-icon></v-btn>
        </v-card-title>
        <v-card-text>
          <div class="d-flex flex-row">
            <div v-for="(board, i) of boardData.filter(x => x.onlyShowOnModal || x.data.length===0)" :key="i" class="d-flex flex-column mr-2 align-center" :style="'height: 75vh; width: '+Math.floor(100/boardData.filter(x => x.onlyShowOnModal || x.data.length===0).length)+'%; border: 1px solid grey; border-radius: 7px; padding: 10px;'">
              <h2 style="min-height: 60px;">{{ utils.parseDispatchStatus(board.status) }} ({{board.count}})</h2>
              <div :ref="`statusScroll_${board.status}`" class="d-flex flex-column " style="width: 100%; height: 100%; overflow-y: scroll;">
                <v-card outlined v-for="(dispatch, j) of board.data" style="width: 100%" class="mb-2" :key="j" @click="rowClick(dispatch.orderId, dispatch.id)" @mousedown.middle.prevent="rowMiddleClick(dispatch.orderId, dispatch.id)">
                  <v-card-text class="d-flex flex-column">
                    <span class="d-flex flex-row justify-space-between">
                      <b v-if="dispatch.id" class='mr-2'>{{ dispatch.orderId }}-{{ dispatch.id }}</b>
                      <b v-else class='mr-2' style="color: rebeccapurple">Order #{{ dispatch.orderId }}</b>
                      <span class="d-flex flex-row align-center">
                        <v-icon v-if="![0, -1, 5, -2].includes(dispatch.status) && dispatch.scheduledOutAt && !(new Date(dispatch.scheduledOutAt) >= new Date())" color="warning">mdi-clock-alert</v-icon>
                        <div class="align-center">
                          <v-icon small class="mr-2">mdi-package</v-icon>
                          <span>{{ dispatch.numItems }}</span>
                        </div>
                      </span>
                    </span>
                    <div style="font-size: 12px;">{{ dispatch.boardDate }}</div>
                    <div>{{ dispatch.customer }}</div>
                    <span v-if="dispatch.address && Object.keys(dispatch.address).length>0" class="d-flex flex-row align-center">
                      <v-icon small class="mr-2">mdi-map-marker</v-icon>
                      <span>
                        <div v-if="dispatch.address.city">{{ dispatch.address.city }}</div>
                        <div v-else style="font-size: 11px;" class="d-flex flex-column">
                          <span style="line-height: 11px;">{{ dispatch.address.line1 }}</span>
                          <span v-if="dispatch.address.line2" style="line-height: 11px;">{{ dispatch.address.line2 }}</span>
                        </div>
                      </span>
                    </span>
                  </v-card-text>
                </v-card>
                <span class="d-flex flex-row justify-space-around">
                  <v-progress-circular v-if="!board.isLoading && board.count!==board.data.length" v-intersect="(entries, observer, isIntersecting) => loadStatus(board.status, entries, observer, isIntersecting)" color="success" indeterminate/>
                </span>
              </div>
            </div>
          </div>
        </v-card-text>
      </v-card>
    </v-dialog>

    <v-snackbar v-model="snackObj.state" :timeout="3000" :color="snackObj.color">
      {{ snackObj.text }}
      <template v-slot:action="{ attrs }">
        <v-btn v-bind="attrs" text @click="snackObj.state = false">Close</v-btn>
      </template>
    </v-snackbar>
  </div>
</template>
<style>
#existingSerials{
  border-collapse: collapse;
}
#existingSerials td, #existingSerials th{
  border: 1px solid #ff8080;
  padding: 5px;
}
#existingSerials tbody tr:hover{
  background: #f50000;
  color: white;
}
</style>
<script>
  import axios from 'axios';
  import { mapGetters } from "vuex";
  import utils from "../../plugins/helpers";
  import _ from 'lodash'
  export default {
    data () {
      return {
        utils: utils,

        serialSearch: '',
        serialSearchResults: [],

        deleteDialog: false,
        deleteConfirmed: true,
        loader: true,
        snackObj: {
          state: false,
          color: '',
          text: ''
        },
        tableTitle: '',
        max25chars: v => v.length <= 25 || 'Input too long!',
        editMode: false,

        routePagination: null,
        defaultPaginationLimit: 10,
        scrollListeners: {},
        previousScrollTops: {},

        allBranches: [],
        allBranchesSelected: true,
        createDispatchLoading: false,

        singular: "Dispatch",
        singularLower: "dispatch",
        plural: "Dispatches",
        pluralLower: "dispatches",

        boardData: [],

        incompleteOrders: [],
        incompleteOrdersLoader: false,
        incompleteOrdersData: {
          sortBy: 'sealedAt',
          filter: 'all'
        },
        incompleteOrdersFilter: {
          speedDialOpen: false
        },

        statuses: [
          {text: "All", value: null},
          {text: "New", value: 0},
          {text: "In Progress", value: 1},
          {text: "Completed", value: 2},
          {text: "Voided", value: -1},
        ],

        dispatchStatuses: [
          {text: "New", value: 0, boardDateRef: 'createdAt'},
          {text: "Scheduled", value: 1, boardDateRef: 'scheduledOutAt'},
          {text: "Out for Delivery", value: 2, boardDateRef: 'historyLast'},
          {text: "Attempted Delivery", value: 3, boardDateRef: 'historyLast'},
          {text: "Delivered", value: 5, boardDateRef: 'completedAt', onlyShowOnModal: true},
          {text: "Voided", value: -1, boardDateRef: 'historyLast', onlyShowOnModal: true},
        ],

        lineErrors: {
          productId: null,
          errors: []
        },

        otherStatusesDialog: {
          isOpen: false,
          isLoading: false
        },

        dispatchIdSearch: '',
        goToDocumentLoader: false,
      }
    },
    async created(){
      try{
        if(this.getGlobalValue('hiddenDispatchStatusesFromFrontend')){
          let statuses = this.getGlobalValue('hiddenDispatchStatusesFromFrontend').split(",").map(x => x.trim())

          for(let status of statuses){
            let sI = this.dispatchStatuses.findIndex(x => x.text===status);
            if(!sI<0) continue;

            this.dispatchStatuses.splice(sI, 1);
          }
        }

        this.routePagination = this.$route.query
      }
      catch (error) {
        console.error(error)
        this.snack(error.msg || error.msg?.message || error, "error");
      }
    },
    async mounted(){
      try {
        this.init = true;

        if(this.isAllowed('dispatch', 'excludeBranchFilter')){
          this.allBranches = this.getBranches.map(x => {
            return {
              label: x.name,
              value: x.id
            }
          });
        }
        else{
          this.allBranches = this.getUser?.metadata?.branchData?.allowed.map(x => {
            return {
              label: this.lookupBranch(x),
              value: x
            };
          });
        }

        await this.loadIncompleteOrders();

        await this.getAllData();
        this.init = false;
      } catch (error) {
        console.error(error);
        this.snack(error.msg || error.msg?.message || error, "error");
      } finally {
        this.loader = false;
      }
    },
    computed: {
      ...mapGetters(['getId', 'getEndpoint', 'lookupUsername', 'getGlobalValue', 'lookupBranch', 'getBranches', 'isAllowed', 'getUser', 'serialNaming']),
    },
    watch: {
      options: {

      }
    },
    methods: {
      normalizeQuery(queryObj, asInt=false) {
        const newQuery = {};
        for (const key in queryObj) {
          newQuery[key] = asInt?parseInt(queryObj[key]):String(queryObj[key]);
        }
        return newQuery;
      },
      async getAllData(){
        try{
          let allData = [];
          for(let status of this.dispatchStatuses){
            if(this.routePagination && Object.keys(this.routePagination).length){
              status.paginationOptions = {
                page: 1,
                limit: (parseInt(this.routePagination[`limit_${status.value}`]) * parseInt(this.routePagination[`page_${status.value}`])) || this.defaultPaginationLimit
              }
            }
            else{
              status.paginationOptions = {
                page: 1,
                limit: this.defaultPaginationLimit
              }
            }

            let obj = {
              data: [],
              status: status.value,
              onlyShowOnModal: status.onlyShowOnModal,
              isLoading: false
            }

            let uriFields = Object.keys(status.paginationOptions).map(x => {
              return x + "=" + (status.paginationOptions[x]!==undefined?encodeURIComponent(status.paginationOptions[x]):'')
            }).join("&");

            let res = await axios.get(`${this.getEndpoint}/api/dispatch/dataForStatus/${obj.status}?${uriFields}`)
            if(res.data.error) throw res.data.error

            let statusArr = [];

            for(let dispatch of res.data.data){
              let statusChanged = false;

              let ref = this.dispatchStatuses.find(x=>x.value === dispatch.status).boardDateRef
              if(ref === "historyLast"){
                if(dispatch.history && dispatch.history.length > 0){
                  dispatch.boardDate = "Last Updated: "+utils.formatDate(dispatch.history[dispatch.history.length-1].createdAt, 'withTime')
                }else{
                  dispatch.boardDate = null
                }
              }
              else if(ref==='scheduledOutAt'){
                dispatch.boardDate = "Due: "+utils.formatDate(dispatch[ref])
              }
              else{
                dispatch.boardDate = dispatch[ref]?utils.formatDate(dispatch[ref], 'withTime'):utils.formatDate(dispatch['updatedAt'], 'withTime')
              }

              dispatch.customer = dispatch.Order.Customer?(dispatch.Order.Customer.name?dispatch.Order.Customer.name:(dispatch.Order.Customer.firstName||dispatch.Order.Customer.lastName?(`${dispatch.Order.Customer.firstName||''} ${dispatch.Order.Customer.lastName||''}`):'-')):"-"

              if(!statusChanged){
                statusArr.push(dispatch);
              }
            }

            obj.data = statusArr;
            obj.count = res.data.total;

            allData.push(obj)

            status.paginationOptions = {
              page: this.routePagination[`page_${status.value}`]?parseInt(this.routePagination[`page_${status.value}`]):1,
              limit: this.routePagination[`limit_${status.value}`]?parseInt(this.routePagination[`limit_${status.value}`]):this.defaultPaginationLimit,
            }
          }

          this.boardData = allData

          let routePag = {}
          for(let status of this.dispatchStatuses){
            routePag[`page_${status.value}`] = status.paginationOptions.page
            routePag[`limit_${status.value}`] = status.paginationOptions.limit
          }

          if(this.routePagination && Object.keys(this.routePagination).length){
            routePag = this.normalizeQuery(JSON.parse(JSON.stringify(this.routePagination)));
          }
          else{
            routePag = this.normalizeQuery(JSON.parse(JSON.stringify(routePag)));
          }
          const isDifferent = JSON.stringify(this.$route.query) !== JSON.stringify(routePag);

          if (isDifferent) {
            await this.$router.replace({query: routePag})
            this.routePagination = this.$route.query
          }

          this.$nextTick(() => {
            this.scrollStatusesToCorrectPage()
          });

        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      async loadIncompleteOrders(sortBy=null, filter=null){
        try{
          this.incompleteOrdersLoader = true;

          if(sortBy) this.incompleteOrdersData.sortBy = sortBy;
          if(filter) this.incompleteOrdersData.filter = filter

          let uriFields = Object.keys(this.incompleteOrdersData).map(x => {
            return x + "=" + (this.incompleteOrdersData[x]!==undefined?encodeURIComponent(this.incompleteOrdersData[x]):'')
          }).join("&");

          let res = await axios.get(`${this.getEndpoint}/api/dispatch/incompleteOrders?${uriFields}`)
          if(res.data.error) throw res.data.error
          this.incompleteOrders = res.data.data;

        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.incompleteOrdersLoader = false;
        }
      },
      async loadStatus(status, entries, observer, isIntersecting){
        try{
          if(!isIntersecting) return;

          let statuses = status===null ? this.dispatchStatuses : this.dispatchStatuses.filter(x => x.value===status);

          for(let status of statuses){
            let board = this.boardData.find(x => x.status===status.value);
            board.isLoading = true;

            if((board.count/status.paginationOptions.limit)<=status.paginationOptions.page) return

            status.paginationOptions.page++;

            let uriFields = Object.keys(status.paginationOptions).map(x => {
              return x + "=" + (status.paginationOptions[x]!==undefined?encodeURIComponent(status.paginationOptions[x]):'')
            }).join("&");

            let res = await axios.get(`${this.getEndpoint}/api/dispatch/dataForStatus/${status.value}?${uriFields}`)
            if(res.data.error) throw res.data.error

            let statusArr = [];

            for(let dispatch of res.data.data){
              let statusChanged = false;

              let ref = this.dispatchStatuses.find(x=>x.value === dispatch.status).boardDateRef
              if(ref === "historyLast"){
                if(dispatch.history && dispatch.history.length > 0){
                  dispatch.boardDate = "Last Updated: "+utils.formatDate(dispatch.history[dispatch.history.length-1].createdAt, 'withTime')
                }else{
                  dispatch.boardDate = null
                }
              }
              else if(ref==='scheduledOutAt'){
                dispatch.boardDate = "Due: "+utils.formatDate(dispatch[ref])
              }
              else{
                dispatch.boardDate = dispatch[ref]?utils.formatDate(dispatch[ref], 'withTime'):utils.formatDate(dispatch['updatedAt'], 'withTime')
              }

              dispatch.customer = dispatch.Order.Customer?(dispatch.Order.Customer.name?dispatch.Order.Customer.name:(dispatch.Order.Customer.firstName||dispatch.Order.Customer.lastName?(`${dispatch.Order.Customer.firstName||''} ${dispatch.Order.Customer.lastName||''}`):'-')):"-"

              if(!statusChanged){
                statusArr.push(dispatch);
              }
            }

            board.data = board.data.concat(statusArr);
            board.count = res.data.total;

            let routePag = this.normalizeQuery(JSON.parse(JSON.stringify(this.routePagination)), true);

            routePag[`page_${status.value}`] = status.paginationOptions.page
            routePag[`limit_${status.value}`] = status.paginationOptions.limit

            routePag = this.normalizeQuery(JSON.parse(JSON.stringify(routePag)));

            const isDifferent = JSON.stringify(this.$route.query) !== JSON.stringify(routePag);

            if (isDifferent) {
              await this.$router.replace({query: routePag})
              this.routePagination = this.$route.query;
            }

            board.isLoading = false;
          }
        } catch (error) {
          console.error(error);
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.loader = false;
        }
      },
      scrollStatusesToCorrectPage(){
        for(let status of this.dispatchStatuses){
          let container = this.$refs[`statusScroll_${status.value}`];
          if(!container || this.scrollListeners[`statusScroll_${status.value}`]){
            continue;
          }
          let scrollTop = 0;
          container = container[0]

          let estChildren = ((status.paginationOptions.page-1)*status.paginationOptions.limit);
          if(container.children.length>=estChildren && estChildren){
            for (let i=0; i<estChildren; i++) {
              if(!container.children) break;
              const itemEl = container.children[i];
              if (itemEl) {
                scrollTop += itemEl.offsetHeight;
              }
            }
            scrollTop+=(container.children[0].offsetHeight*(status.paginationOptions.page-1))

          }

          this.previousScrollTops[`statusScroll_${status.value}`] = container.scrollTop

          container.scrollTop = scrollTop;

          container.addEventListener('scroll', _.debounce(() => {
            this.handleContainerScroll(status, container);
          }, 100));

          this.scrollListeners[`statusScroll_${status.value}`] = true;
        }
      },
      handleContainerScroll(status, container) {
        if(!container || !container.children || !container.children.length) return;
        const itemHeight = container.children[0].offsetHeight;
        const limit = status.paginationOptions.limit;

        const currentScrollTop = container.scrollTop;

        const prevScrollTop = this.previousScrollTops[`statusScroll_${status.value}`];
        const up = currentScrollTop < prevScrollTop;

        this.previousScrollTops[`statusScroll_${status.value}`] = currentScrollTop;

        const currentPage = Math.floor(currentScrollTop / (itemHeight * limit)) + 1;

        if(!up){
          if((currentPage-1)<=status.paginationOptions.page) return;
        }

        if (currentPage !== status.paginationOptions.page) {
          status.paginationOptions.page = currentPage;

          this.$router.replace({
            query: {
              ...this.$route.query,
              [`page_${status.value}`]: currentPage,
            }
          });
        }
      },
      updateBranchFilter(id){
        if(id===0){
          if(this.allBranchesSelected){ //the value is already being set true by the component
            this.options.selectedBranches = [];
          }
          else{
            this.options.selectedBranches = this.allBranches.map(x => x.value);
          }
        }
        else{
          if(this.options.selectedBranches.length===0) this.allBranchesSelected = true;
          else this.allBranchesSelected = false;
        }
      },
      goToDocument(){
        try{
          if(!this.dispatchIdSearch?.trim()) return;

          this.goToDocumentLoader = true

          let doc = this.dispatchIdSearch.split("-");

          if(isNaN(doc[0]) || !Number.isInteger(parseInt(doc[0]))) throw "Invalid Dispatch ID";

          this.rowClick(doc[0], doc.length>1?doc[1]:null);

        } catch (error) {
          console.error(error)
          this.snack(error.msg || error.msg?.message || error, "error");
        } finally {
          this.goToDocumentLoader = false;
        }
      },
      getRowRoute(oid, did=null){
        let route = `/dispatch/view/${oid}`
        if(did){
          route+=`?curr=${did}`
        }
        return route;
      },
      rowClick(oid, did=null){
        this.$router.push({ path: this.getRowRoute(oid, did)})
      },
      rowMiddleClick(oid, did=null){
        this.utils.openInNewTab(this.$router,this.getRowRoute(oid, did))
      },
      snack(text, color=""){
        this.snackObj.text = text;
        this.snackObj.state = true;
        this.snackObj.color = color;
      },
      async openOtherStatusesDialog(){
        this.otherStatusesDialog.isOpen = true;

        this.$nextTick(() => {
          setTimeout(() => {
            this.scrollStatusesToCorrectPage();
          }, 0);
        });
      },
      closeOtherStatusesDialog(){
        this.otherStatusesDialog.isOpen = false;
      }
    }
  }
</script>
